import IconAdvisor from './IconAdvisor.vue'
import IconCoordinator from './IconCoordinator.vue'
import IconImplementor from './IconImplementor.vue'
import IconInitiator from './IconInitiator.vue'
import IconInspirator from './IconInspirator.vue'
import IconMotivator from './IconMotivator.vue'
import IconObserver from './IconObserver.vue'
import IconSupporter from './IconSupporter.vue'

// Re-export components
export {
	IconAdvisor,
	IconCoordinator,
	IconImplementor,
	IconInitiator,
	IconInspirator,
	IconMotivator,
	IconObserver,
	IconSupporter
}

// Trait color mapping (includes 'reformer' alias for backwards compatibility)
export const traitColors = {
	reformer: '#838091',
	implementor: '#838091',
	initiator: '#D43949',
	motivator: '#EF7950',
	inspirator: '#FECC30',
	advisor: '#BBCA4A',
	supporter: '#68BC8D',
	coordinator: '#49B4BC',
	observer: '#6489B9'
}

// Trait icon component references (includes 'reformer' alias for backwards compatibility)
export const traitIconComponents = {
	reformer: IconImplementor,
	implementor: IconImplementor,
	initiator: IconInitiator,
	motivator: IconMotivator,
	inspirator: IconInspirator,
	advisor: IconAdvisor,
	supporter: IconSupporter,
	coordinator: IconCoordinator,
	observer: IconObserver
}

// Helper function to get icon component by trait name
export function getTraitIcon(name) {
	return traitIconComponents[name] || IconImplementor
}
